/* eslint-disable */
import {
  Form,
  Input,
  Modal,
  Select,
  Space,
  Button,
  Tooltip,
  message,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
} from "react";
import {
  MailOutlined,
  CheckOutlined,
  CloseOutlined,
  MenuOutlined,
  HomeOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import "./index.css";
import moment from "moment";
import dayjs from "dayjs";
import parse from 'html-react-parser';
import AddModal from "@/views/AccountPayable/UtilityPayment/component/AddModal" ;
import { CustomTable, CustomTableExtend, CustomUpload } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import { useLocation } from "react-router-dom";
const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [openApproval, setOpenApproval] = useState(false);
  const [approvedOrRejected, setApprovedOrRejected] = useState('Approved');
  const [approvalForm,] = Form.useForm();
  const [selectedList, setSelectedList] = useState([]);
  const [propTypeList, setPropTypeList] = useState([]);

  const [filedModalFlag, setFiledModalFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [detailRecord, setDetailRecord] = useState({});
  
  const initTableHead = {
    vendid: null,
    prop: null,
    addressUnits: null,
    glTitle: null,
    unit: null,
    payBy: null,
    invoiceTnt: null,
    dueDate:null,
    payAmount: null,
    groupedPayments: null,
    customer:null,
    approvalStatus:null,
    rejectedReason:null,
    usid:null,
    historyUserId:null,
    updatedDate:null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 100})
  }

  const [addopen, setAddOpen] = useState(false);
  const [addRecord, setAddRecord] = useState(null);
  const [form] = Form.useForm();
  const [formTenant] = Form.useForm();
  
  const handleCellClick = async (record, item, flag = false) => {
    const response = await http.get(api.getIssuedCK, { params: {
      vendorPaymentId: item.vendorPaymentId,
      propId: item.propId,
      unitId: item.unitId,
    }});
    const val = response.code === '1' ? response.data : {}
    const invoiceDateTemp = dayjs(flag ? val.invoiceDate : new Date())
    setAddRecord({ 
      ...record,
      ...val,
      propId: item.propId,
      unitId: item.unitId,
      invoiceDate: invoiceDateTemp,
      amount: val?.amount || 0,
      serviceStartDate: val?.serviceStartDate && dayjs(val?.serviceStartDate) || null,
      serviceEndDate: val?.serviceEndDate && dayjs(val?.serviceEndDate) || null,
      invoiceTenantDate: val?.invoiceTenantDate && dayjs(val?.invoiceTenantDate) || null,
      invoiceTenant: String(val.invoiceTenant),
      foreignId: val?.foreignId || record?.vendorUtilPaymentId,
      filePaths: val?.filePaths || [],
      isEdit: flag,
      noSubmitBtn: true,
      unitIdTemp: val?.unit || '',
      usid: val?.usid
    });
    setAddOpen(true);
  };

  const paymentColumns = [0, 1, 2].map(index => ({
    title: "issuedCheck",
    dataIndex: `issuedCheck_${index}`,
    width: 120,
    onCell: () => ({
      style: { 
        padding: '8px',
      }
    }),
    render: (text, record) => {
      if (!record.groupedPayments || !Array.isArray(record.groupedPayments)) {
        return <div>-</div>;
      }

      const titleMatch = {
        "green": "(Cashed)",
        "#dd4b39": "(Not Cash)",
        "#f39c12": "(Voided)",
      }
      
      const payment = record.groupedPayments[index];
      if (!payment) return <div>-</div>;
      const textColor = payment.color || "";
      const title = titleMatch?.[textColor] || ''
  
      return (
        <div style={{ color: textColor, cursor: 'pointer' }} onClick={() =>  handleCellClick(record, payment, true)}>
          {title && <span style={{ 
            borderBottom: `1px dashed ${textColor}`,
            paddingBottom: '2px' // 控制下划线与文字的间距
          }}>
            {title}
          </span> || null}
          <br />
          <span style={{ 
            borderBottom: `1px dashed ${textColor}`,
            paddingBottom: '2px' // 控制下划线与文字的间距
          }}>
            {payment.invoiceDate 
              ? moment(new Date(payment.invoiceDate)).format("MM/DD/YYYY") 
              : '-'}
          </span>
          <br />
          <span style={{ 
            borderBottom: `1px dashed ${textColor}`,
            paddingBottom: '2px'
          }}>
            {payment.amount 
              ? new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 2,
                }).format(parseFloat(payment.amount))
              : '-'}
          </span>
        </div>
      );
    },
  }));

  // 定义列，包括输入框
  const initColumns = [
    {
      title: "#",
      dataIndex: "#",
      width:50,
    },
    {
      title: "Vendor",
      dataIndex: "vendid",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      width: 150,
      onChange: (e) => tableFilterFn(e, 'vendid'),
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>{text}</span>
          <Tooltip title={parse(record.preCalPre)}>
            <MenuOutlined
              style={{ marginLeft: 8, cursor: "pointer", color: "#a94442" }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Prop",
      dataIndex: "prop",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'prop'),
    },
    {
      title: 'Type - Units',
      dataIndex: "propType",
      titleType: 'Select',
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: propTypeList,
      onChange: e => tableFilterFn(e, 'propType', 'Select'),
    },
    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'remark'),
    },
    {
      title: "GL-Title",
      dataIndex: "glTitle",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'glTitle'),
    },
    // {
    //   title: "Unit",
    //   dataIndex: "unit",
    //   titleType: "Input",
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, 'unit'),
    // },
    {
      title: "PayBy",
      dataIndex: "payBy",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'payBy'),
    },
    {
      title: "Invoice Tnt",
      dataIndex: "invoiceTnt",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'invoiceTnt'),
    },
    {
      title: 'Due Date',
      dataIndex: "dueDate",
      titleType: "DatePicker",
      width: 100,
      onChange: (e) => tableFilterFn(e, 'dueDate', 'DatePicker'),
    },
    {
      title: "PayAmount",
      dataIndex: "payAmount",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      // isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, 'payAmount'),
      render: (text, record) => {
        return (
          <Button
            type="link"
            onClick={() => (setDetailRecord(record), setFiledModalFlag(true))}
            className="CA-AS-AmountStyle"
          >
            {commonFn.amountToDollarFn(text)}
          </Button>
        )
      },
    },
    ...paymentColumns,
    // {
    //   title: "Customer#",
    //   dataIndex: "customerAccount",
    //   titleType: "Input",
    //   width: 120,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, 'customerAccount'),
    // },
    // {
    //   title: "Approval Status",
    //   dataIndex: "approve",
    //   titleType: "Input",
    //   width: 150,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, 'approve'),
    // },
    {
      title: "Rejected Reason",
      dataIndex: "rejectedReason",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'rejectedReason'),
    },
    // {
    //   title: "User ID",
    //   dataIndex: "usid",
    //   titleType: "Input",
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, 'usid'),
    // },
    // {
    //   title: "Approved By",
    //   dataIndex: "historyUserId",
    //   titleType: "Input",
    //   width: 120,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, 'historyUserId'),
    //   render: () => { return ''}
    // },
    // {
    //   title: 'Updated Date',
    //   dataIndex: "updatedDate",
    //   titleType: "DatePicker",
    //   width: 120,
    //   onChange: (e) => tableFilterFn(e, 'updatedDate', 'DatePicker'),
    // },
  ];

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const searchParams = getPropsParamsFn()
    const params = {
      page: current || pagination.current ,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      usid: searchParams.email,
      type: searchParams.module,
      batch: searchParams.batch,
    };

    const response = await http.get(api.getCheckApprovalList, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    // setSelectedList([])
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }))
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setSelectedList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
  
  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 100)
  }, [refreshKey])


  const getDictionaryFn = async() => {
    const response = await http.get(api.getDictionary, { params: {
        type:'util_payment',
        value: 'propType'
    }});
    setPropTypeList(response)
  };

  useEffect(() => {
    getDictionaryFn()
  }, [])

  useEffect(() => {
    if(propTypeList.length){
      setColumns(initColumns);
    }
  }, [propTypeList]);

  const [btnLoading, setBtnLoading] = useState(false);
  
  // 提交数据
  const handleSubmit = async () => {
    setBtnLoading(true)
    const values = await approvalForm.validateFields();
    // 合并数据：表格选中的数据 + 表单数据
    const data = {
      ...values,
      ids: selectedList.map(item => item.vendorPaymentId),
      approvedOrRejected,
      batchGroup: getPropsParamsFn().batch,
      // usid: selectedList.map(item => item.usid)
    };
    const response = await http.post(api.getCheckApprovalApprove, data);
    if(response.code === '1'){
      message.success(`${approvedOrRejected} success!`);
      setOpenApproval(false);
      setRefreshKey(+new Date())
    }else{
      message.error(`${approvedOrRejected} failed!`);
    }
    setBtnLoading(false)
  };
 
  const approveOrRejectFn = (approvedOrRejected) => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: '1',
      noLimit: 'no'
    });
  };

  const getPropsParamsFn = () => {
    const searchParams = new URLSearchParams(location.search);
 
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('DetailDownload') && 'download']}
      >
        <div className="topLeft">
          <Space size="small">
            {commonFn.btnAuthorityFlag('Approval') && <Tooltip
              placement="topLeft"
              title="Approval The Requests For Approval From Employee"
            >
              <Button className="btnAgreed" style={{marginRight: 0}} onClick={() => approveOrRejectFn('Approved')}>
                <CheckOutlined />
                Approval
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('Reject') && <Tooltip
              placement="topLeft"
              title="Reject The Requests For Approval From Employee"
            >
              <Button className="btnRefused" style={{marginLeft: 0}} onClick={() => approveOrRejectFn('rejected')}>
               <CloseOutlined />
                Reject
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('SelectedAmount') && <Button className="btnAmount" style={{cursor: 'text'}}>Selected Amount:{
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(selectedList.map(item => item.payAmount).reduce((acc, curr) => acc + curr, 0))
            }</Button> || null}
          </Space>
        </div>
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollX={2100}
        tableScrollY="350px"
        tableCss="checkApprovalDetailTable"
      />
 
      {/* modal */}
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openApproval}
        maskClosable={false}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to approve these checks?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: `${approvedOrRejected === 'Approved' ? 'Approve' : 'Reject'} ${selectedList.length} Check(s).`,
                }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="noLimit"
            label={<span >Do you want to approve the amount over {<span style={{color:'#a94442',textDecoration:'underline'}}>
              {
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(5000)
              }
            </span>} with signature</span>}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "no",
                  label: "No",
                },
                {
                  value: "yes",
                  label: "Yes",
                },
              ]}
            />
          </Form.Item>

          {approvedOrRejected !=='Approved' && <Form.Item
            name="rejectedReason"
            label="Rejected Reason"
            style={{ flex: 2 }}
          >
            <Input placeholder="" />
          </Form.Item>}
        </Form>
      </Modal>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <HomeOutlined style={{ marginRight: "8px" }} />
            File
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={filedModalFlag}
        onCancel={() => setFiledModalFlag(false)}
        footer={null}
        maskClosable={false}
        // destroyOnClose={true}
        width="80%"
      >
      <div
        key={detailRecord?.vendorPaymentId}
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <CustomUpload
          setFilePaths={setFilePaths} 
          filePaths={filePaths} 
          setBtnDisabled={setBtnDisabled}
          btnDisabled={btnDisabled}
          isEdit={true}
          vendorPaymentId={detailRecord?.vendorPaymentId || undefined}
          foreignId={detailRecord?.vendorPaymentId || undefined}
          type={detailRecord?.type || undefined}
          customConfig={{
            pdfHeight: '62vh',
            noShowUpload: true,
            noSubmitBtn: true,
          }}
        />
        <div style={{textAlign: 'center', marginTop: 20}}>
          <Button onClick={() => setFiledModalFlag(false)}>
            cancel
          </Button>
        </div>
      </div>
      </Modal>
      <AddModal 
        addopen={addopen}
        form={form}
        formTenant={formTenant}
        handleModalSubmitlFn={() => {setAddOpen(false); getTableListFn(pagination.current, pagination.pageSize, tableHead)}}
        handleModalCancelFn={() => setAddOpen(false)}
        record={addRecord}
      />
    </div>
  );
});
export default MainTable;
